/// <reference path="../../_ext/editors/ItemGridEditor.ts" />
namespace TabAurous.Inventory {

    import fld = MeltingReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MeltingReturnItemsEditor extends _Ext.ItemGridEditor<MeltingReturnItemsRow> {
        protected getColumnsKey() { return "Inventory.MeltingReturnItems"; }
        protected getDialogType() { return MeltingReturnItemsDialog; }
        protected getLocalTextPrefix() { return MeltingReturnItemsRow.localTextPrefix; }

        protected form: MeltingReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = true;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        private Master;
        static baseitemcheck: number;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public items = [];
        public isUpdate: number;
        public canUpdate: number;
        isEditable: boolean;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.isEditable = this.slickGrid.getOptions().editable;

        }


        public setEditValue(source: MeltingRow, property) {

            //super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }
        public Editable() {
            this.isEditable = true;
        }

        protected createToolbarExtensions(): void {

        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = num;

            //var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            //Department.referencedFields = [fld.DepartmentId];
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(),this);

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.isEditable) {
                        Q.confirm('Are you sure want to delete? ', () => {
                            let CurrentStock: Stock.StockItemRow;

                            Stock.StockItemService.GetProductDetails({
                                ProductId: item.ProductId,
                                AttributeId: item.AttributeId,
                            },
                                response =>
                                    CurrentStock = response.Entity,
                                { async: false }
                            );
                            if (CurrentStock.Weight >= item.Weight) {
                                var id = this.id(item);
                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                            } else {
                                q.alert('', 'Insufficient Weight to delete Item', true, 2999);
                                return;
                            }
                        });
                        this.view.refresh();
                    } else {
                        q.alert('', 'Voucher is in ReadOnly Mode', true, 2999);
                        return;
                    }
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.000')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {


                var receivableweight = (this.parentDialog as MeltingDialog).form.ReceivableWeight.value;
                if (item.CalcOnId == 4 || item.CalcOnId == 5) {

                    if (value <= receivableweight) {
                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        q.Alert('Invalid Entry', 'Entered weight is more than issued weight', 1000, false);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    }

                }

            }


            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as MeltingDialog).calculateReceivedData();
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.000');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");


            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {
                    var requiredalloy = (this.parentDialog as MeltingDialog).form.RequiredAlloyTemp.value;
                    var issuedalloy = (this.parentDialog as MeltingDialog).form.IssuedAlloy.value;
                    var companyid = (this.parentDialog as MeltingDialog).form.CompanyId.value;
                    var departmentid = parseInt((this.parentDialog as MeltingDialog).form.DepartmentId.value);
                    var vouchertypeId = (this.parentDialog as MeltingDialog).form.VoucherTypeId.value;
                    if (requiredalloy != issuedalloy) {
                        q.alert('', 'No alloy issued can not prcoeed', true, 2999);
                        return;
                    }
                    //OMS.ProductSelectGrid.ItemType = 1;
                    var grid = Common.MetalSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        KaratId: parseInt((this.parentDialog as MeltingDialog).form.KaratId.value),
                        MetalColorId: parseInt((this.parentDialog as MeltingDialog).form.MetalColorId.value)
                    } 
                    var purity = (this.parentDialog as MeltingDialog).form.Purity.value;
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = [];


                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: OMS.ProductMasterRow) {

                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****


                            // #endregion



                            var item: MeltingReturnItemsRow = {
                                Attribute: value.Attribute,
                                AttributeId: value.AttributeId,
                                ProductTypeId: value.ProductTypeId,
                                ProductTypeName: value.ProductTypeName,
                                CalcOnId: value.CalcOnId,
                                CompanyId: companyid,
                                DepartmentId: departmentid,
                                ItemTypeId: value.ItemTypeId,
                                ProductId: value.ProductId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                VoucherTypeId: vouchertypeId,
                                Purity: purity,
                                Weight: value.Weight,
                                CategoryId: value.CategoryId,
                                SubCategoryId: value.SubCategoryId,
                                PureWeight: value.Weight * value.Purity,
                                KaratName: value.KaratName,
                                MetalColorName: value.MetalColorName,
                                StockAllocation: false,
                                Line_No: 0,
                                BagNo: '',
                                LotNo: '',


                            };
                            orddetails.push(item);

                        });
                        for (let MeltingDetail of orddetails) {
                            MeltingDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = MeltingDetail;
                            this.view.addItem(MeltingDetail);
                        }
                        //new MeltingDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });



            return buttons;
        }



        // #endregion




        //validateEntity(row: MeltingReturnItemsRow, id: number) {
        //    if (!super.validateEntity(row, id))
        //        return false;                                   

        //    row.ProductCode = OMS.ProductMasterRow.getLookup().itemById[row.ProductId].ProductCode;
        //    return true;
        //}    

        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in Melting details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}